exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customPage {\n    text-align: center;\n    font-size: 18px;\n}\n.odd {\n    background-color:#ffffff ;\n}\n.even {\n    background-color:#e6e6e6;\n}\n.errorMessage{\n    color: red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-list/reimbursement-manager-list.component.css
// module id = ../../../../../src/app/reimbursement/reimbursement-manager-list/reimbursement-manager-list.component.css
// module chunks = main